import React, {Component} from 'react';

class LiveroomWeekBar extends Component {
    constructor () {
        super();
        this.state = {
            show: true
        }
        this.handleCloseWeekBar = this.handleCloseWeekBar.bind(this);
        this.handleRetrunDay = this.handleRetrunDay.bind(this);
    }
    handleCloseWeekBar(){
        this.setState({
            show:false
        });
        let day = this.handleRetrunDay();
        localStorage.setItem('wkWeekBar', day);
    }
    handleRetrunDay() {
        //按天存储
        let date = new Date(),
            year = date.getFullYear(),
            month = date.getMonth() + 1,
            day = date.getDate();
        return year.toString() + month + day;
    }
    componentWillMount() {
        let day = this.handleRetrunDay();
        if(localStorage.getItem('wkWeekBar') === day){
            this.setState({show: false});
        }
    }
    render() {
        const {show} = this.state;
        if (!show) {
            return null;
        }
        return (
            <div className="liveroom-week-bar" style={{marginBottom: '-10px', display: 'block', position:'relative'}}>
                <span className="close" onClick={this.handleCloseWeekBar} style={{position: 'absolute',width:'18px',height:'18px',right:'17px',top:'17px',padding:'3px'}}><img src='https://static-1253442168.file.myqcloud.com/xupload/20180921_close.png' alt=""/></span>
                <img onClick={()=>window.location.href = this.props.weekUrl} src="https://static-1253442168.image.myqcloud.com/picture/7832811_a3da602434ddf0665a1e557f06938a3b.jpg"/>
                <span style={{
                    position: 'absolute',
                    bottom: '13%',
                    left: '50%',
                    color: '#fff',
                    fontSize: '0.8rem',
                    lineHeight: '0.8rem',
                    transform: 'translateX(-50%)'}}>
                    {this.props.timeRange}
                </span>
            </div>
        )
    }
}
export default LiveroomWeekBar


// WEBPACK FOOTER //
// ./src/components/liveroom/LiveroomWeekBar.js